module.exports = __webpack_public_path__ + "img/joy.ed5b1e8d.jpeg";